import VAnimateCss from './dist';

export default VAnimateCss;


//////////////////
// WEBPACK FOOTER
// ./node_modules/v-animate-css/index.js
// module id = 4Yho
// module chunks = 1